// src/components/PrivateRoute.js
import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const PrivateRoute = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  // If there is no authenticated user, redirect to /login and forward the search parameters.
  if (!user) {
    return <Navigate to={`/login${location.search}`} />;
  }
  return <Outlet />;
};

export default PrivateRoute;